export default {
  // 節點類型描述
  expandNode: "這是擴展點",

  // 標籤相關
  tags: "標籤",

  // 平台相關
  platform: "平台",
  analysisId: "分析ID",
  userId: "用戶ID",
  deviceId: "設備ID",

  // 錢包平台名稱
  bitpieWallet: "比特派錢包",
  imToken: "imToken",

  // 字段標籤
  exchangeName: "交易所名稱",
  bankCardNumber: "銀行卡號",
  username: "用戶名",
  userIdField: "用戶id",
  phoneNumber: "手機號",
  surveyUser: "已調證用戶",

  // 註釋中的統計信息（保留用於將來可能的顯示）
  inflowCount: "流入計數",
  outflowCount: "流出計數",
  usdtInflowAvgQuantity: "USDT 轉入平均數量",
  usdtInflowOpponentCount: "USDT 轉入對手數",
  usdtInflowTotalQuantity: "USDT 轉入總數量",
  usdtOutflowAvgQuantity: "USDT 轉出平均數量",
  usdtOutflowOpponentCount: "USDT 轉出對手數",
  usdtOutflowTotalQuantity: "USDT 轉出總數量",
};
